export type BindableBoolean = boolean | 'true' | 'false';
export type BindableNumber = number | string;

export function getBoolean(value: BindableBoolean) {
  return value === 'false' ? false : !!value;
}

export function getInt(value: BindableNumber) {
  return typeof value === 'string' ? parseInt(value) : value;
}
